import { isCreateAgentQuestionPrompt } from '@/features/chat/agentQuestion/isCreateAgentQuestionPrompt.js'
import { isGeneratedArtifactUserMessage } from '@/utils/generatedArtifactAssistantPayload'
import { createAssistantStreamSession } from '../streamSession'
import { runAgentQuestionTurn } from './runAgentQuestionTurn.js'
import { runApiCompletionStream } from './runApiCompletionStream.js'
import { demoPromptsAllowed, runDemoMatchedTurn } from './runDemoMatchedTurn.js'
import { runGeneratedArtifactTurn } from './runGeneratedArtifactTurn.js'
import { runPhase1ChatStream } from '@/features/chat/phase1/runPhase1ChatStream'
import { isPhase1ChatStreamConfigured } from '@/services/chatStream/postChatStream'

export function runInitialAssistantTurn(p) {
  const { tid, pendingId, trimmed, apiMessages, signal, setMessagesByThreadId } = p
  const { priorMessages = [], allowResponseComponentDemo = true } = p

  const session = createAssistantStreamSession(signal)
  const ctx = { tid, pendingId, trimmed, signal, session, setMessagesByThreadId, onChatEvent: p.onChatEvent }
  const settle = () => p.onSettled?.()

  // A clarification answer arrives with its stream already open and accepted.
  // Checked before the demo matchers because the answer text is the user's own
  // words in a template, and a matcher hijacking it would silently discard a
  // turn the server has already committed.
  if (p.openStream) {
    runPhase1ChatStream({ ...ctx, apiMessages, model: p.model, refinement: p.refinement, openStream: p.openStream, onSettled: p.onSettled })
    return
  }
  if (p.refinement && isPhase1ChatStreamConfigured()) {
    runPhase1ChatStream({ ...ctx, apiMessages, files: p.files, proposalId: p.proposalId, researchMode: p.researchMode, refinement: p.refinement, model: p.model, onSettled: p.onSettled })
    return
  }
  if (runDemoMatchedTurn(ctx, { trimmed, priorMessages, files: p.files, allowResponseComponentDemo })) {
    settle()
    return
  }
  if (isCreateAgentQuestionPrompt(trimmed)) {
    runAgentQuestionTurn(ctx)
    settle()
    return
  }
  if (demoPromptsAllowed() && isGeneratedArtifactUserMessage(trimmed)) {
    runGeneratedArtifactTurn(ctx)
    settle()
    return
  }
  if (isPhase1ChatStreamConfigured()) {
    runPhase1ChatStream({ ...ctx, apiMessages, files: p.files, proposalId: p.proposalId, researchMode: p.researchMode, refinement: p.refinement, model: p.model, onSettled: p.onSettled })
    return
  }
  runApiCompletionStream({ ...ctx, apiMessages, onSettled: p.onSettled })
}
